/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types import-spacing */

import {ElementRef} from '@angular/core';

import {Dialog} from './dialog';
import {Logger} from '../../util/logger';
import {IValidatorCallBack} from './i.validator.call.back';
import {IOkCallBack} from './i.ok.call.back';
import {BlobType, Blob} from '../../models/blob';

import * as $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';


/**
 *
 * @class AddBlobUploadDialog
 *
 * @brief dialog for uploading files as a blob type.
 *
 * Tutorial on drag n' drop uploading
 * @link https://www.smashingmagazine.com/2018/01/drag-drop-file-uploader-vanilla-js/
 *
 * HTML 5 DND
 * @link https://www.html5rocks.com/en/tutorials/file/dndfiles/
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class AddBlobUploadDialog extends Dialog {

  private pendingFiles: File[] = [];

  /** the type of the dimension */
  private type: BlobType = BlobType.Scenario;

  /** the kinds of dimensions we are allowing */
  private allowed: BlobType[] = [BlobType.Scenario, BlobType.Plant, BlobType.Traffic];

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef
  ) {

    super(host);

    this.title = 'Add (upload) Blob(s)';
    this.icon  = '<i class="fas fa-plus"></i>';

    Logger.debug('[AddBlobUploadDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    this.validator    = validator ? validator : null;
    this.success      = success   ? success   : null;
    this.pendingFiles = [];

    Logger.debug('[AddBlobUploadDialog] opening...');

    this.type = BlobType.Scenario;

    let types: BlobType[]   = [];

    if (options) {

      if (options.types) {

        if (options.types.length > 0) {

          types = options.types;
          this.type = types[0];
        }
      }
    }

    if (types.length > 0) {

      this.type = types[0];
    }

    const body = $(this.host).find('.modal-body');

    let typePick = `
<div class="control gui-radio-toolbar">

  <input class="add-blob-upload-kind" id="add-upload-scenario-blob" type="radio" name="type"  value="scenario" checked>
  <label for="add-upload-scenario-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-scenario-20.png" style="margin-right: 8px;">Scenario
  </label>

  <input class="add-blob-upload-kind" id="add-upload-plant-blob" type="radio" name="type"  value="plant">
  <label for="add-upload-plant-blob" class="radio" style="margin-right: 12px;">
    <img src="assets/images/blob-icons/blob-plant-20.png" style="margin-right: 8px;">Plant
  </label>

  <input class="add-blob-upload-kind"  id="add-upload-traffic-blob" type="radio" name="type"  value="traffic">
  <label for="add-upload-traffic-blob" class="radio">
    <img src="assets/images/blob-icons/blob-traffic-20.png" style="margin-right: 8px;">Traffic
  </label>

</div>`;

    if (types.length > 0) {

      /* general set of types was provided */

      typePick = `<div class="dropmenu new-empty-type-inputs no-highlight" style="">`;

      typePick += `<div id="upload-general-type-inputs" class="control gui-radio-toolbar" aria-describedby="tooltip">
  <input class="add-blob-upload-kind" id="upload-general-type-blob" type="radio" name="type"  value="` +
        Blob.stringOfType(types[0]) +
        `" checked>
  <label id="upload-general-type-input-label" for="upload-general-type-blob" class="radio" style="margin-right: 12px; display: inline-block; margin-left: 8px;">
    <img src="assets/images/blob-icons/`;

      typePick += Blob.iconOfType(types[0]);

      typePick += `" style="margin-right: 8px;">`;

      typePick += Blob.stringOfType(types[0]);

      typePick += `</label>`;


      typePick += `<div class="dropmenu-down-content" style="padding: 0; width: 300px;">`;

      types.forEach((value: BlobType) => {

        typePick += `<label class="gui-button upload-general-type-click" type="`;
        typePick += Blob.stringOfType(value);
        typePick += `" style="display: inline-block; margin: 4px;"><img src="assets/images/blob-icons/`;
        typePick += Blob.iconOfType(value);
        typePick += `" style="margin-right: 8px;">`;
        typePick += Blob.stringOfType(value);
        typePick += `  </label>`;

      });

      typePick += `<div style="clear: both; height: 1px;"></div></div></div>`;

      typePick += `</div>`;

    }

    const html = `
${typePick}
<div style="clear: both; margin-top: 12px;">

<div id="add-blob-upload-drop-area" class="drop-area">
  <form class="add-blob-upload-form">
    <p>Upload multiple files with the file dialog or by dragging and dropping onto this dashed region</p>
    <input type="file" id="add-blob-upload-files" multiple style="display: none;">
    <label
      class="gui-button primary"

      onClick="document.getElementById('add-blob-upload-files').click(event)">
      Browse
    </label>
  </form>
</div>

</div>

<div class="gui-error-line"></div>
    `;

    $(body).html(html);

    /* add behaviors */

    setTimeout(() => {

      $('.upload-general-type-click').on('click', (e) => {

        $('#upload-general-type-blob').val($(e.currentTarget).attr('type'));

        const type: BlobType = Blob.typeofString($(e.currentTarget).attr('type') as string);

        $('#upload-general-type-input-label').html(`<img src="assets/images/blob-icons/` +
          Blob.iconOfType(type) +
          `" style="margin-right: 8px;">` +
          Blob.stringOfType(type)
        );

        this.type = type;

      });

      /* watch for file section or drop */

      $('input#add-blob-upload-files[type="file"]').on('change', (e) => {

        // @ts-ignore
        this.pendingFiles = Array.from(e.target.files);

        this.validate(true);
      });

      /* watch for type changes */

      $('input.add-blob-upload-kind[type=radio][name=type]').on('input', (e) => {

        this.type = Blob.typeofString($(e.currentTarget).val() as string);

        this.validate();
      });

      /* - - - - - -  add in drag n' drop behaviors */

      /* get the drop box */

      const dropArea: HTMLElement = $('#add-blob-upload-drop-area').get(0);

      /* prevent bubble up, we're handling drag n' drop for this area */

      ['dragenter', 'dragover', 'dragleave', 'drop'].forEach((eventName) => {

        dropArea.addEventListener(eventName, (e) => {

          e.preventDefault();
          e.stopPropagation();

        }, false);

      });

      ['dragenter', 'dragover'].forEach(eventName => {
        dropArea.addEventListener(eventName, (e) => {

          $('add-blob-upload-drop-area').addClass('highlight');

        }, false);

      });

      ['dragleave', 'drop'].forEach(eventName => {
        dropArea.addEventListener(eventName, (e) => {

          $('add-blob-upload-drop-area').removeClass('highlight');

        }, false);

      });

      dropArea.addEventListener('drop', (e) => {

        const           dt = e.dataTransfer;
        this.pendingFiles  = Array.from(dt.files);

        this.validate(true);

      }, false);

    }, 50);

    /* disable the Ok button...until we have valid input */

    this.validate();
  }

  disable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).attr('disabled', 'true');
    $(ok).addClass('disabled');
  }

  enable() {

    const ok = $(this.host).find('.modal-ok-button');

    $(ok).removeAttr('disabled');
    $(ok).removeClass('disabled');

  }

  /** show a validation error */
  error(msg: string) {

    const display = $(this.host).find('.gui-error-line');

    $(display).html(msg);
  }

  /* don't enable the Ok button until we have what we need. */
  validate(transition: boolean = false) {

    this.error('');

    /* assume its bad */

    this.disable();

    if (!this.validator) {

      if (this.allowed.find(x => x === this.type)) {

        this.error('Unknown kind of input: ' + Blob.stringOfType(this.type));

        return ;
      }

      if (this.pendingFiles.length === 0) {

        this.error('No files selected.');
      }

      this.enable();

      /* if we make it through validation checks, and we're allowed to transition, then do it. */

      if (transition) {

        /* click the ok button for them, and trigger via ModelComponent */

        const ok = $(this.host).find('.modal-ok-button');

        $(ok).click();
      }

    } else {

      /* wrap validation in a promise, so its ok if its asynchronous */

      const p = new Promise((resolve, reject) => {

        this.validator({files: this.pendingFiles, type: this.type}, resolve, reject);

      }).then((data: any) => {

        this.pendingFiles = data.files as File[];
        this.type         = data.type  as BlobType;

        this.enable();

        if (transition) {

          /* click the ok button for them, and trigger via ModelComponent */

          const ok = $(this.host).find('.modal-ok-button');

          $(ok).click();
        }

      }).catch((error) => {

        /* show the validation error */

        this.error(error);

      });

    }

  }

  /** dialog is closing */
  public close() {

    Logger.debug('[AddBlobUploadDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[AddBlobUploadDialog] accepted: ', this.pendingFiles, this.type);

    if (this.success) {

      /* inform the client */

      this.success( {files: this.pendingFiles, type: this.type});
    }

  }
}


